import {
  AfterContentChecked, AfterContentInit, AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {DataType} from '../../pusblisher/ipublisher';
import {DataGrid} from '../../DoraData/data-grid';
import {DataTupla} from '../../DoraData/data-tupla';
import {MessageGridSelected} from '../../messages/message-grid-selected';
import {DataRow} from '../../DoraData/data-row';
import {MessageSeriesSelected} from '../../messages/message-series-selected';
import {MessageRowsSelected} from '../../messages/message-rows-selected';
import {MessageColumnsSelected} from '../../messages/message-columns-selected';
import {DataTuplaDescription} from '../../DoraData/data-tupla-description';
import {TUPLA_TYPE} from '../../DoraData/data-base';
import {DoraProperty} from '../../Decorators/Decorator';
import {MessageColumnsVisible} from '../../messages/message-columns-visible';
import {timer} from 'rxjs';

@Component({
  selector: 'dora-data-grid',
  templateUrl: './dora-data-grid.component.html',
  styleUrls: ['./dora-data-grid.component.scss']
})
export class DoraDataGridComponent extends WidgetBaseComponent implements OnInit {
  @DoraProperty
  private idgrid = '';
  @DoraProperty
  private checkBoxDisabled = false;
  @DoraProperty
  private columnsSelectable = true;
  @DoraProperty
  private seriesReverseOrder = false;
  @DoraProperty
  private numberFormat = '#.#';

  private dataGrid: DataGrid = null;
  private columnsSelected: string[] = [];
  private columnsVisible: string[] = [];

  @ViewChild('innerWrapper') innerWrapper: ElementRef;
  @ViewChild('shadowLeft') shadowLeft: ElementRef;
  @ViewChild('shadowRight') shadowRight: ElementRef;
  @ViewChild('dagTable') dagTable: ElementRef;

  // opacity
  private opacityLeft = 0.0;
  private opacityRight = 0.0;

  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    this.readData();

    this.messageService.getMessage(this.EventChannel, MessageColumnsVisible, this.CallerName).subscribe(message => {
      this.columnsVisible = (message.data as MessageColumnsVisible).idColumns;
      this.rebuildVisibleColumns();
    });
    this.messageService.getMessage(this.EventChannel, MessageGridSelected, this.CallerName).subscribe(message => {
      this.idgrid = (message.data as MessageGridSelected).idGrid;

      this.readData();
    });

    this.messageService.getMessage(this.EventChannel, MessageRowsSelected, this.CallerName).subscribe(message => {
      const idRows = (message.data as MessageRowsSelected).idRows;

      // select rows
      this.dataGrid.selectRows(idRows);

      // build series and fire event
      // tslint:disable-next-line:max-line-length
      this.messageService.sendMessage(this.EventChannel, new MessageSeriesSelected(this.dataGrid.rowsSelected2Series(this.seriesReverseOrder, this.columnsSelected)), this.CallerName);
    });

    this.messageService.getMessage(this.EventChannel, MessageColumnsSelected, this.CallerName).subscribe( message => {
      this.columnsSelected = (message.data as MessageColumnsSelected).idColumns;

      this.dataGrid.selectTuplaDescription(this.columnsSelected);

      // build series and fire event
      // tslint:disable-next-line:max-line-length
      this.messageService.sendMessage(this.EventChannel, new MessageSeriesSelected(this.dataGrid.rowsSelected2Series(this.seriesReverseOrder, this.columnsSelected)), this.CallerName);
    });
  }

  private readData(): void {
    if (this.idgrid === '') {
      // idgrid not set
      return;
    }
    // Read table list
    this.read([this.idgrid], DataType.GRID).subscribe((data: any) => {
      this.dataGrid = (data as DataGrid);
      this.onNewData();
    });
  }

  private onNewData(): void {
    this.dataGrid.selectColumnsByType(TUPLA_TYPE.NUMBER);
    this.rebuildSelectedColumns();
    this.rebuildVisibleColumns();

    const myTime = timer(1000);
    myTime.subscribe(value => {
      this.onScroll();
    });


  }
  public getRowCssClass(rowIndex: number, dataRow: DataRow): string {
    let result: string;

    result = dataRow.CssFormat;
    if (rowIndex % 2) {
      result += ' odd';
    } else {
      result += ' even';
    }

    if (dataRow.selected) {
      result += ' selected';
    }

    return result;
  }

  public getHeaderCssClass(cellIndex: number, baseName: string, dataTuplaDescription: DataTuplaDescription): string {
    let result = baseName;

    result += ' ' + baseName + cellIndex.toString();

    if (!cellIndex) {
      result += ' ' + baseName + 'First';
    }

    if (cellIndex === this.dataGrid.tuplasDescription.length - 1) {
      result += ' ' + baseName + 'Last';
    }

    // only NUMBER columns are selectable
    if (dataTuplaDescription.Type === TUPLA_TYPE.NUMBER && this.columnsSelectable === true) {
      // class for select
      result += ' ' + baseName + ((dataTuplaDescription.selected === true) ? 'selected' : 'unselected');
    }

    return result;
  }

  public getColSpan(dataRow: DataRow, cellIndex: number, dataTupla: DataTupla = null): number {
    if (dataTupla === null) {
      return 0;
    }

    const colSpan = dataRow.getColSpan(cellIndex);
    return colSpan;
  }
  public getCellCssClass(cellIndex: number, baseName: string, dataTupla: DataTupla = null): string {
    let result = baseName;
    let idx = this.dataGrid.tuplasDescription.findIndex(tuplaDescription =>
      tuplaDescription.Id === dataTupla.Id );

    if (idx === undefined) {
      idx = cellIndex;
    }
    result += ' ' + baseName + idx.toString();

    if (idx === 0) {
      result += ' ' + baseName + 'First';
    }

    if (idx === this.dataGrid.tuplasDescription.length - 1) {
      result += ' ' + baseName + 'Last';
    }

    if (dataTupla != null) {
      result += ' type-' + TUPLA_TYPE[dataTupla.Type];

      // empty/no-empty
      if (dataTupla.Value === '') {
        result += ' empty';
      } else {
        result += ' no-empty';
      }

      if (dataTupla.Type === TUPLA_TYPE.NUMBER) {
        if (dataTupla.Value > 0) {
          result += ' pos';
        } else if (dataTupla.Value < 0) {
          result += ' neg';
        } else {
          result += ' equ';
        }
      }
    }
    return result;
  }

  public getCellValue(dataTupla: DataTupla): string {
    return dataTupla.getFormattedValue('-', this.numberFormat);
  }

  private rebuildSelectedColumns(): void {
    this.columnsSelected = [];
    this.dataGrid.tuplasDescription.forEach((x: DataTuplaDescription) => {
      if (x.selected) {
        this.columnsSelected.push(x.Id);
      }
    });
  }

  private rebuildVisibleColumns(): void {
    if (this.columnsVisible.length === 0 || this.dataGrid === null) {
      return;
    }
    this.dataGrid.setColumnsVisible(this.columnsVisible);
  }
  // User Events
  public onRowClick(dataRow: DataRow): void {
    dataRow.swapSelected();

    // tslint:disable-next-line:max-line-length
    this.messageService.sendMessage(this.EventChannel, new MessageSeriesSelected(this.dataGrid.rowsSelected2Series(this.seriesReverseOrder, this.columnsSelected)), this.CallerName);

    // fire event of selected row
    this.messageService.sendMessage(this.EventChannel, new MessageRowsSelected(this.dataGrid.getIdSelectedRows()), this.CallerName);
  }

  public onHeaderClick(tuplaDescription: DataTuplaDescription): void {
    if (tuplaDescription.Type === TUPLA_TYPE.NUMBER && this.columnsSelectable === true) {
      tuplaDescription.switchSelected();

      this.rebuildSelectedColumns();

      // build series and fire event
      // tslint:disable-next-line:max-line-length
      this.messageService.sendMessage(this.EventChannel, new MessageSeriesSelected(this.dataGrid.rowsSelected2Series(this.seriesReverseOrder, this.columnsSelected)), this.CallerName);
    }
  }

  public onScroll(): void {
    if (this.innerWrapper === undefined) {
      return;
    }
    const tableScrollLeft = this.innerWrapper.nativeElement.scrollLeft;
    const tableScrollRight = this.dagTable.nativeElement.offsetWidth -
      this.innerWrapper.nativeElement.offsetWidth -
      this.innerWrapper.nativeElement.scrollLeft;

    this.opacityLeft = this.getScrollOpacity(this.shadowLeft.nativeElement, tableScrollLeft);
    this.opacityRight = this.getScrollOpacity(this.shadowRight.nativeElement, tableScrollRight);
  }
  private getScrollOpacity(shadowElement, scrollPosition): number {
    const shadowElemWidth = shadowElement.offsetWidth;

    if ((scrollPosition / shadowElemWidth) <= 0 ) {
      return 0.0;
    } else if ( scrollPosition <= shadowElemWidth ) {
      return scrollPosition / shadowElemWidth;
    }

    return 1.0;
  }
}
